import { Logo } from "@lendcord/concord";

// MARKETING_URL is injected via webpack.DefinePlugin (see webpack.config.js) —
// same env var docs/state-management.md's "Environment variables" table
// already reserves for "Back to home" links, just not used anywhere yet.
const MARKETING_URL = process.env.MARKETING_URL || "/";

// A light-background bar above BrandPanel/the auth form — BrandPanel's own
// background is the accent green, which the full-color logo (dark text,
// bright green mark) reads poorly against. Putting the one logo mark here
// instead, on a plain surface, fixes that rather than working around it.
export function AuthHeader() {
  return (
    <header className="border-b border-border bg-surface-raised px-6 py-4">
      <a href={MARKETING_URL} className="inline-block" aria-label="Lendcord">
        <Logo variant="full" />
      </a>
    </header>
  );
}
